import React, { useEffect, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
type Announcement = {
  address: string;
  schedule: string;
};
const announcements: Announcement[] = [{
  address: "18 Harbour Isle Dr #102",
  schedule: "Open House · Sept 19 · 1:00–4:00 PM ET"
}, {
  address: "20 Harbour Isle Dr W #106",
  schedule: "Open House · Sept 19 · 1:00–4:00 PM ET"
}];
const shimmerFlecks = [{
  left: "4%",
  top: "24%",
  delay: 0.2
}, {
  left: "10%",
  top: "66%",
  delay: 1.9
}, {
  left: "16%",
  top: "74%",
  delay: 1.1
}, {
  left: "22%",
  top: "31%",
  delay: 3.0
}, {
  left: "28%",
  top: "57%",
  delay: 2.3
}, {
  left: "35%",
  top: "18%",
  delay: 0.7
}, {
  left: "40%",
  top: "72%",
  delay: 2.6
}, {
  left: "48%",
  top: "37%",
  delay: 1.5
}, {
  left: "54%",
  top: "20%",
  delay: 1.8
}, {
  left: "59%",
  top: "76%",
  delay: 0.3
}, {
  left: "66%",
  top: "48%",
  delay: 2.7
}, {
  left: "72%",
  top: "19%",
  delay: 1.2
}, {
  left: "78%",
  top: "70%",
  delay: 2.1
}, {
  left: "84%",
  top: "35%",
  delay: 1.4
}, {
  left: "90%",
  top: "67%",
  delay: 0.5
}, {
  left: "96%",
  top: "27%",
  delay: 2.0
}];
export function OpenHouseAnnouncement() {
  const [activeIndex, setActiveIndex] = useState(0);
  const prefersReducedMotion = useReducedMotion();
  useEffect(() => {
    if (prefersReducedMotion) {
      return undefined;
    }
    const interval = window.setInterval(() => {
      setActiveIndex(index => (index + 1) % announcements.length);
    }, 4800);
    return () => window.clearInterval(interval);
  }, [prefersReducedMotion]);
  const announcement = announcements[activeIndex];
  return <aside className="relative overflow-hidden border-b border-amber-200/35 bg-amber-100 px-5 py-3 text-stone-950 sm:px-10 lg:px-14" aria-label="Open house announcements" data-id="element-42" data-mp="1tw6w91t97nmm">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-43" data-mp="11eb0wgl6bc3w">
        {shimmerFlecks.map(fleck => <motion.span key={`${fleck.left}-${fleck.top}`} className="absolute h-[2px] w-[2px] rounded-full bg-slate-500" style={{
        left: fleck.left,
        top: fleck.top,
        boxShadow: "0 0 4px 1px rgba(71, 85, 105, 0.6)"
      }} animate={prefersReducedMotion ? {
        opacity: 0.45
      } : {
        opacity: [0.16, 0.8, 0.22]
      }} transition={prefersReducedMotion ? undefined : {
        duration: 2.4,
        delay: fleck.delay,
        repeat: Infinity,
        repeatType: "mirror",
        ease: "easeInOut"
      }} data-id="element-44" data-mp="wf88bvmdqyct" />)}
      </div>
      <div className="relative mx-auto flex w-full max-w-7xl items-center justify-center gap-3" aria-live="polite" data-id="element-45" data-mp="177nv8c4tv3cw">
        <span className="hidden shrink-0 text-xs font-bold uppercase tracking-[0.16em] text-amber-900 sm:inline" data-id="element-46" data-mp="1c4o2gqdeyc5l">Featured</span>
        <motion.div key={activeIndex} className="min-w-0 text-center" initial={prefersReducedMotion ? false : {
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-47" data-mp="1h2po9j284pkr">
          <p className="text-sm font-bold leading-5 sm:inline sm:text-base" data-id="element-48" data-mp="gyyk5s8wh65u">
            {announcement.address}
          </p>
          <p className="text-xs font-semibold leading-5 text-amber-900 sm:ml-3 sm:inline sm:text-sm" data-id="element-49" data-mp="772ik77luxwv">
            {announcement.schedule}
          </p>
        </motion.div>
      </div>
    </aside>;
}